(function () {
const root = document.querySelector('[data-pawli-cfg]');
if (!root) return;
const data = JSON.parse(root.querySelector('[data-cfg-data]').textContent);
const T = data.text || {};
const PHOTO_KEY = 'pawli_photo';
const CUTOUT_KEY = 'pawli_cutout';
const COMP = 1024;
window.PAWLI_PRODUCT_URL = location.pathname;
const canvas = root.querySelector('.pawli-cfg__canvas');
const ctx = canvas.getContext('2d');
const view2d = root.querySelector('[data-view-2d]');
const view3d = root.querySelector('[data-view-3d]');
const pillow3d = root.querySelector('[data-pillow3d]');
const progressEl = root.querySelector('[data-progress]');
const barEl = root.querySelector('[data-bar]');
const ptextEl = root.querySelector('[data-ptext]');
const emptyEl = root.querySelector('[data-empty]');
const colorPanel = root.querySelector('[data-color-panel]');
const sizeButtons = Array.from(root.querySelectorAll('.pawli-cfg__size'));
const atcBtn = root.querySelector('[data-atc]');
const atcLabel = root.querySelector('[data-atc-label]');
const viewLabel = root.querySelector('[data-view-label]');
const drawer = root.querySelector('[data-note-drawer]');
const noteField = root.querySelector('[data-note]');
let color = 'white';
let view = '2d';
let cutoutImg = null;
const comp = document.createElement('canvas');
comp.width = comp.height = COMP;
const cctx = comp.getContext('2d');
let selected = data.variants[0] || null;
let angle = 0;
let raf = null;
let threeActive = false;
window.customerNotes = '';
let hostedPhotoUrl = null;
let preuploadToken = 0;
let preuploadTimer = null;
let preuploadPromise = null;
let progTimer = null, progVal = 0;
function loadImg(src) {
return new Promise((res, rej) => {
const i = new Image();
i.crossOrigin = 'anonymous';
i.onload = () => res(i);
i.onerror = rej;
i.src = src;
});
}
function makeSilhouette(img, w, h, fill) {
const s = document.createElement('canvas');
s.width = Math.max(1, Math.round(w));
s.height = Math.max(1, Math.round(h));
const g = s.getContext('2d');
g.drawImage(img, 0, 0, s.width, s.height);
g.globalCompositeOperation = 'source-in';
g.fillStyle = fill;
g.fillRect(0, 0, s.width, s.height);
return s;
}
function recompose() {
cctx.clearRect(0, 0, COMP, COMP);
if (cutoutImg) {
const margin = COMP * 0.16;
const availW = COMP - margin * 2;
const availH = COMP - margin * 2;
const ir = cutoutImg.width / cutoutImg.height;
let w = availW;
let h = availW / ir;
if (h > availH) { h = availH; w = availH * ir; }
const dx = (COMP - w) / 2;
const dy = (COMP - h) / 2;
const border = Math.max(6, Math.round(Math.min(w, h) * 0.03));
const borderColor = color === 'black' ? '#1a1a1a' : '#ffffff';
const sil = makeSilhouette(cutoutImg, w, h, borderColor);
const steps = 32;
const ring = Math.max(2, border / 3);
for (let r = border; r > 0; r -= ring) {
for (let i = 0; i < steps; i++) {
const a = (i / steps) * Math.PI * 2;
cctx.drawImage(sil, dx + Math.cos(a) * r, dy + Math.sin(a) * r, w, h);
}
}
cctx.drawImage(cutoutImg, dx, dy, w, h);
}
const url = comp.toDataURL('image/png');
updateThumbs(url);
updatePillow3d(url);
if (threeActive && window.Pillow3D && cutoutImg) {
try { window.Pillow3D.update(cutoutImg, { color: color }); } catch (e) { }
}
}
function updateThumbs(url) {
url = url || comp.toDataURL('image/png');
sizeButtons.forEach((b) => {
const t = b.querySelector('[data-thumb]');
if (t) t.style.backgroundImage = 'url(' + url + ')';
});
}
function updatePillow3d(url) {
if (pillow3d) pillow3d.src = url || comp.toDataURL('image/png');
}
function fitCanvas() {
const size = Math.min(root.querySelector('.pawli-cfg__stage').clientWidth, 800) || 520;
const dpr = Math.min(window.devicePixelRatio || 1, 2);
canvas.width = size * dpr;
canvas.height = size * dpr;
}
function animate() {
raf = requestAnimationFrame(animate);
if (threeActive) return;
if (view !== '2d') return;
const w = canvas.width, h = canvas.height;
ctx.clearRect(0, 0, w, h);
angle += 0.012;
const sx = Math.cos(angle);
ctx.save();
ctx.translate(w / 2, h / 2);
ctx.scale(sx === 0 ? 0.001 : sx, 1);
const s = Math.min(w, h);
ctx.drawImage(comp, -s / 2, -s / 2, s, s);
ctx.restore();
}
function showProgress(on) { progressEl.hidden = !on; }
function showEmpty(on) { emptyEl.hidden = !on; }
function setProgress(pct) { barEl.style.width = (pct || 0) + '%'; ptextEl.textContent = (T.processing || 'Processing…') + ' ' + (pct || 0) + '%'; }
function startProgress() {
showEmpty(false); showProgress(true);
progVal = 2; setProgress(progVal);
clearInterval(progTimer);
progTimer = setInterval(() => {
progVal += Math.max(0.5, (90 - progVal) * 0.05);
if (progVal >= 90) progVal = 90;
setProgress(Math.round(progVal));
}, 180);
}
function bumpProgress(pct) { if ((pct || 0) > progVal) { progVal = Math.min(90, pct); setProgress(Math.round(progVal)); } }
function stopProgress() { clearInterval(progTimer); progTimer = null; }
function showError() {
stopProgress();
showProgress(false);
ptextEl.textContent = T.error || 'Failed';
progressEl.hidden = false;
}
async function downscaleBlob(blob, maxDim) {
const img = await loadImg(URL.createObjectURL(blob));
const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
if (scale >= 1) return blob;
const c = document.createElement('canvas');
c.width = Math.round(img.width * scale);
c.height = Math.round(img.height * scale);
c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
return await new Promise((res) => (c.toBlob ? c.toBlob((b) => res(b || blob), 'image/jpeg', 0.92) : res(blob)));
}
function cleanCutout(img, minAlpha) {
const w = img.width, h = img.height;
const c = document.createElement('canvas'); c.width = w; c.height = h;
const g = c.getContext('2d');
g.drawImage(img, 0, 0);
try {
const d = g.getImageData(0, 0, w, h);
const a = d.data, t = minAlpha || 80;
for (let i = 3; i < a.length; i += 4) { if (a[i] < t) a[i] = 0; }
const n = w * h;
const lab = new Int32Array(n), stack = new Int32Array(n);
let cur = 0, best = 0, bestSize = 0;
for (let s = 0; s < n; s++) {
if (a[s * 4 + 3] === 0 || lab[s]) continue;
cur++; let size = 0, sp = 0; stack[sp++] = s; lab[s] = cur;
while (sp > 0) {
const p = stack[--sp]; size++;
const x = p % w, y = (p / w) | 0;
if (x > 0 && a[(p - 1) * 4 + 3] !== 0 && !lab[p - 1]) { lab[p - 1] = cur; stack[sp++] = p - 1; }
if (x < w - 1 && a[(p + 1) * 4 + 3] !== 0 && !lab[p + 1]) { lab[p + 1] = cur; stack[sp++] = p + 1; }
if (y > 0 && a[(p - w) * 4 + 3] !== 0 && !lab[p - w]) { lab[p - w] = cur; stack[sp++] = p - w; }
if (y < h - 1 && a[(p + w) * 4 + 3] !== 0 && !lab[p + w]) { lab[p + w] = cur; stack[sp++] = p + w; }
}
if (size > bestSize) { bestSize = size; best = cur; }
}
if (best) { for (let p = 0; p < n; p++) if (lab[p] !== best) a[p * 4 + 3] = 0; }
g.putImageData(d, 0, 0);
} catch (e) { }
return c;
}
async function removeBg(dataURL) {
const srcBlob = await (await fetch(dataURL)).blob();
const attempts = [null, 1200, 800];
let outBlob = null, lastErr = null;
for (let i = 0; i < attempts.length; i++) {
try {
const inBlob = attempts[i] ? await downscaleBlob(srcBlob, attempts[i]) : srcBlob;
outBlob = await window.removeBackground(inBlob, (pct) => bumpProgress(pct));
break;
} catch (e) { lastErr = e; }
}
if (!outBlob) throw (lastErr || new Error('background removal failed'));
const rawCut = await loadImg(URL.createObjectURL(outBlob));
cutoutImg = await loadImg(cleanCutout(rawCut, 80).toDataURL('image/png'));
try {
const c = document.createElement('canvas');
c.width = cutoutImg.width; c.height = cutoutImg.height;
c.getContext('2d').drawImage(cutoutImg, 0, 0);
sessionStorage.setItem(CUTOUT_KEY, c.toDataURL('image/png'));
} catch (e) {}
}
async function finalizeBuild() {
stopProgress();
setProgress(95);
await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
recompose();
setProgress(100);
await new Promise((r) => setTimeout(r, 200));
showProgress(false);
schedulePreupload();
}
async function processDataURL(dataURL) {
startProgress();
try { await removeBg(dataURL); await finalizeBuild(); }
catch (e) { showError(); }
}
async function loadCutoutFromCache(dataURL) {
cutoutImg = await loadImg(dataURL);
recompose();
}
window.pawliOnNewPhoto = async function (dataURL) {
sessionStorage.removeItem(CUTOUT_KEY);
await processDataURL(dataURL);
if (selected) selectSize(selected.id, false);
setView('2d');
};
function setView(v) {
view = v;
view2d.hidden = v !== '2d';
view3d.hidden = v !== '3d';
if (viewLabel) viewLabel.textContent = v === '2d' ? (T.view3d || '3D') : (T.view2d || '2D');
if (window.Pillow3D && threeActive) { if (v === '2d') window.Pillow3D.resume(); else window.Pillow3D.pause(); }
}
root.querySelectorAll('.pawli-cfg__tab').forEach((tab) => {
tab.addEventListener('click', () => {
const which = tab.dataset.tab;
if (which === 'reupload') { if (window.openUploadOptions) window.openUploadOptions(); return; }
if (which === 'color') { colorPanel.hidden = !colorPanel.hidden; toggleActive(tab, !colorPanel.hidden); return; }
if (which === 'note') { openDrawer(); return; }
if (which === 'view') { setView(view === '2d' ? '3d' : '2d'); toggleActive(tab, view === '3d'); return; }
});
});
function toggleActive(tab, on) { tab.classList.toggle('is-active', !!on); }
colorPanel.querySelectorAll('.pawli-cfg__sw').forEach((sw) => {
sw.addEventListener('click', () => {
color = sw.dataset.color;
colorPanel.querySelectorAll('.pawli-cfg__sw').forEach((x) => x.classList.toggle('is-active', x === sw));
recompose();
schedulePreupload();
});
});
function parseCm(str) {
const m = String(str || '').match(/([\d]+(?:[.,][\d]+)?)\s*(cm|m)\b/i);
if (!m) return 0;
let n = parseFloat(m[1].replace(',', '.'));
if (/^m$/i.test(m[2])) n = n * 100;
return n > 0 ? n : 0;
}
const PERSON_CM = Number(data.personCm) > 0 ? Number(data.personCm) : 170;
const SIZE_BOOST = Number(data.sizeBoost) > 0 ? Number(data.sizeBoost) : 100;
function applyPillowSize(v) {
if (!pillow3d) return;
const cm = parseCm(v.title) || parseCm(v.size);
let h = cm > 0 ? (cm / PERSON_CM) * (SIZE_BOOST / 100) * 100 : 20;
h = Math.max(4, Math.min(240, h));
pillow3d.style.height = h + '%';
pillow3d.style.width = 'auto';
}
function selectSize(idOrSize, goto3d) {
const key = String(idOrSize);
const v = data.variants.find((x) => String(x.id) === key) || data.variants.find((x) => x.size === key) || data.variants[0];
if (!v) return;
selected = v;
const btn = sizeButtons.find((b) => b.dataset.id === String(v.id));
sizeButtons.forEach((b) => b.classList.toggle('is-active', b === btn));
applyPillowSize(v);
if (atcLabel) atcLabel.textContent = (data.atcLabel || 'In den Warenkorb') + ' ' + v.price;
if (goto3d) { setView('3d'); const vt = root.querySelector('[data-tab="view"]'); if (vt) vt.classList.add('is-active'); }
}
sizeButtons.forEach((b) => b.addEventListener('click', () => selectSize(b.dataset.id, true)));
function openDrawer() { noteField.value = window.customerNotes || ''; drawer.hidden = false; drawer.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
function closeDrawer() { drawer.classList.remove('is-open'); document.documentElement.style.overflow = ''; setTimeout(() => { drawer.hidden = true; }, 50); }
root.querySelector('[data-note-skip]').addEventListener('click', closeDrawer);
root.querySelector('[data-note-confirm]').addEventListener('click', () => { window.customerNotes = noteField.value.trim(); closeDrawer(); });
drawer.addEventListener('click', (e) => { if (e.target === drawer) closeDrawer(); });
function toast(msg) {
let el = document.querySelector('.pawli-toast');
if (!el) { el = document.createElement('div'); el.className = 'pawli-toast'; document.body.appendChild(el);
el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#1a1a1a;color:#fff;padding:12px 18px;border-radius:10px;z-index:2000;font-family:var(--pawli-font-body,sans-serif);max-width:90vw;text-align:center;'; }
el.textContent = msg;
el.style.opacity = '1';
clearTimeout(el._t);
el._t = setTimeout(() => { el.style.opacity = '0'; }, 4000);
}
function exportUploadBlob() {
const S = 640;
const ex = document.createElement('canvas');
ex.width = ex.height = S;
ex.getContext('2d').drawImage(comp, 0, 0, S, S);
return new Promise((resolve) => {
if (ex.toBlob) ex.toBlob((b) => resolve(b), 'image/png');
else resolve(null);
});
}
async function preuploadPhoto() {
if (!cutoutImg || !selected) return;
const token = ++preuploadToken;
try {
const blob = await exportUploadBlob();
if (!blob || token !== preuploadToken) return;
const fd = new FormData();
fd.append('id', String(selected.id));
fd.append('quantity', '1');
fd.append('properties[_photo]', blob, 'pawli.png');
const res = await fetch('/cart/add.js', { method: 'POST', body: fd });
if (!res.ok) return;
const item = await res.json();
const key = item && item.key;
const url = item && item.properties && item.properties._photo;
if (key) fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) }).catch(function () {});
if (token === preuploadToken && typeof url === 'string' && /^https?:\/\//.test(url)) {
hostedPhotoUrl = url;
}
} catch (e) { }
}
function schedulePreupload() {
hostedPhotoUrl = null;
preuploadToken++;
clearTimeout(preuploadTimer);
preuploadTimer = setTimeout(() => { preuploadPromise = preuploadPhoto(); }, 250);
}
atcBtn.addEventListener('click', async () => {
if (!cutoutImg) { toast(T.needPhoto || 'Bitte lade zuerst ein Foto hoch'); return; }
if (!selected && data.variants[0]) selected = data.variants[0];
if (!selected) { toast(T.needPhoto || ''); return; }
atcBtn.disabled = true;
try {
if (!hostedPhotoUrl) {
try { if (preuploadPromise) await preuploadPromise; } catch (e) {}
if (!hostedPhotoUrl) { try { await preuploadPhoto(); } catch (e) {} }
}
if (hostedPhotoUrl) {
const fd = new FormData();
fd.append('id', String(selected.id));
fd.append('quantity', '1');
fd.append('properties[_photo]', hostedPhotoUrl);
fd.append('properties[_color]', color);
fd.append('properties[_notes]', window.customerNotes || '');
const r = await fetch('/cart/add.js', { method: 'POST', body: fd });
if (r.ok) { window.location.href = '/cart'; return; }
}
const blob = await exportUploadBlob();
const build = (withPhoto) => {
const fd = new FormData();
fd.append('id', String(selected.id));
fd.append('quantity', '1');
if (withPhoto && blob) fd.append('properties[_photo]', blob, 'pawli-' + selected.size + '.png');
fd.append('properties[_color]', color);
fd.append('properties[_notes]', window.customerNotes || '');
return fd;
};
let res = await fetch('/cart/add.js', { method: 'POST', body: build(true) });
if (!res.ok) {
res = await fetch('/cart/add.js', { method: 'POST', body: build(false) });
}
if (res.ok) { window.location.href = '/cart'; return; }
const err = await res.json().catch(() => ({}));
toast(T.cartError || 'Fehler');
atcBtn.disabled = false;
} catch (e) {
toast(T.cartError || 'Fehler');
atcBtn.disabled = false;
}
});
async function init() {
fitCanvas();
window.addEventListener('resize', fitCanvas);
const cached = sessionStorage.getItem(CUTOUT_KEY);
const raw = sessionStorage.getItem(PHOTO_KEY);
let bgPromise = null;
if (!cached && raw) {
startProgress();
bgPromise = removeBg(raw).catch((e) => { showError(); });
} else if (!cached && !raw) {
showEmpty(true);
}
if (window.Pillow3D) {
try {
const ok = await window.Pillow3D.init(view2d, { bg: '#f5f0eb' });
if (ok) { threeActive = true; canvas.style.display = 'none'; }
} catch (e) { }
}
if (data.variants[0]) selectSize(data.variants[0].id, false);
if (cached) {
await loadCutoutFromCache(cached);
} else if (bgPromise) {
await bgPromise;
if (cutoutImg) await finalizeBuild();
} else {
recompose();
}
setView('2d');
animate();
}
init();
})();
